import React, { useState, useEffect, useRef } from 'react';
import '../../../styles/mainContents.css'
import { setNoReturnsNeededCbState, fetchInventoryDetailPartnos, setNoRotatesNeededCbState, fetchInventory, fetchCustomers, fetchTransfers, fetchOrders, fetchCustnoDetail, fetchSubmitCustnoDetail } from '../../../redux/actions/PostActions';
import { useSelector, useDispatch, connect } from 'react-redux';
import { Link, Switch, useHistory } from 'react-router-dom';
import MUIDataTable from 'mui-datatables';
import { createTheme, ThemeProvider  } from '@mui/material/styles'
import { superSearch } from '@codewell/super-search';
import EmptyMuiDataTable from '../../layout/EmptyMuiDataTable';
import { NoEncryption } from '@mui/icons-material';
import moment from "moment";
import ReactToPrint from 'react-to-print';
import CustomerCorePrintPage from './PrintPages/CustomerCorePrintPage'
import { Tooltip, IconButton } from '@mui/material';
import { Print } from '@mui/icons-material'
import RotateRequestTable from '../../shared/RotateRequestTable';
import ReturnsTable from '../../shared/ReturnsTable'; 

function Customers(props) {

  const dispatch = useDispatch();
  const history = useHistory();

  const { dispatchSetNoReturnsNeededCbState, returnsState, noReturnsNeededCbState, fetch_InventoryDetailPartnos, noRotatesNeededCbState,dispatchSetNoRotatesNeededCbState, rotateRequestState, custCoreBankState, fetch_landingPageStates, corePickupState, fetch_submitCustnoDetail, customersState, authreducerState, fetch_customers, custServerResponseState, fetch_custnoDetail, custDetailHeaderState, custnoDetailState } = props;
  const [printBtnClickedState, setPrintBtnClickedState] = useState(false)
  // const [coresEnteredState, setCoresEnteredState] = useState(false)

  const [ returnsCommentState, setReturnsCommentState ] = useState({
    ORIGINALINVNO: '',
    ORIGINALTICKET: '',
    ORIGINALPO: '',                              
  }); 

  useEffect( () => { 
    fetch_customers(authreducerState.user)     
  }, []);

  const columnsCustomers = [
    {
      name: "CUSTID",
      label: "Custid",
      options: {
        filter: false,
        display: false,
        setCellHeaderProps: () => ( {style: {
          maxWidth:"85px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",
        }}),         
        setCellProps: () => ( {style: {
          maxWidth:"55px", 
          wordWrap: "break-word",
          padding: "14px 4px 14px 16px",
        }}),        
      },
    },  
    {
      name: "USER_CUST_PERMISSIONID",
      label: "USER_CUST_PERMISSIONID",
      options: {
        filter: false,
        display: false,
      },
    },      
    {
      name: "CUSTNO",
      label: "Custno",
      options: {
        filter: false,
        sort: true,
        setCellHeaderProps: () => ( {style: {
          maxWidth:"85px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",
        }}),         
        setCellProps: () => ( {style: {
          maxWidth:"55px", 
          wordWrap: "normal",
          padding: "14px 4px 14px 16px",
        }}),        
      },
    },
    {
      name: "CUSTNAME",
      label: "Custname",
      options: {
        filter: false,
        sort: true,
        setCellHeaderProps: () => ( {style: {
          maxWidth:"85px", 
          wordWrap: "normal", 
          padding: "2px 4px 0px 16px",
        }}),         
        setCellProps: () => ( {style: {
          maxWidth:"125px", 
          wordWrap: "break-word",
          padding: "14px 4px 14px 16px",         
          fontSize: ".875em", 
        }}),        
      },
    },
    {
      name: "LOC",
      label: "Loc",
      options: {
        filter: true,
        sort: true,
        setCellHeaderProps: () => ( {style: {
          maxWidth:"80px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",
          textAlign: "center",
        }}),         
        setCellProps: () => ( {style: {
          maxWidth:"72px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 37px",          
        }}),        
      },
    },      
    {
      name: "CITY",
      label: "City",
      options: {
        filter: true,
        sort: true,
        setCellHeaderProps: () => ( {style: {
          maxWidth:"80px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",
        }}),         
        setCellProps: () => ( {style: {
          maxWidth:"72px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",
        }}),        
      },
    },
    {
      name: "STATE",
      label: "State",
      options: {
        filter: true,
        sort: true,
        setCellHeaderProps: () => ( {style: {
          maxWidth:"80px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",
          textAlign: "center",
        }}),         
        setCellProps: () => ( {style: {
          maxWidth:"72px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",
          paddingLeft: "45px",
        }}),        
      },
    },  
    {
      name: "LAST_ROTATE_REQUEST_DATE",
      label: "Last Rotate Request",
      options: {
        filter: true,
        sort: true,
        setCellHeaderProps: () => ( {style: {
          maxWidth:"80px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",
          textAlign: "center",
        }}),         
        setCellProps: () => ( {style: {
          maxWidth:"72px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",
          paddingLeft: "45px",
        }}),   
        customBodyRender: value => {
          return value !== '' ? moment(new Date(value)).format('MM/DD/YYYY') : '';
        }     
      },
    },
    {
      name: "LASTCOREINVOICED",
      label: "LAST CORE RETURN INVOICED",
      options: {
        filter: true,
        sort: true,
        setCellHeaderProps: () => ( {style: {
          maxWidth:"80px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",
          textAlign: "center",
        }}),         
        setCellProps: () => ( {style: {
          maxWidth:"72px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",
          paddingLeft: "45px",
        }}),   
        customBodyRender: value => {
          return value !== '' ? moment(new Date(value)).format('MM/DD/YYYY') : '';
        }     
      },
    }, 
    {
      name: "LASTBATTERYSALEINVOICED",
      label: "LAST BATTERY SALE INVOICED",
      options: {
        filter: true,
        sort: true,
        setCellHeaderProps: () => ( {style: {
          maxWidth:"80px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",
          textAlign: "center",
        }}),         
        setCellProps: () => ( {style: {
          maxWidth:"72px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",
          paddingLeft: "45px",
        }}),   
        customBodyRender: value => {
          return value !== '' ? moment(new Date(value)).format('MM/DD/YYYY') : '';
        }     
      },
    },                    
  ]

  const optionsCustomers = {
    filterType: "checkbox",
    selectableRows: 'none',
    responsive: "standard",
    download:false,
    sortOrder: {
      name: 'CUSTNAME',
      direction: 'asc'
    },    
    search: true,
    searchOpen: true,
    //searchAlwaysOpen: true,
    searchPlaceholder: 'SEARCH CUSTOMERS',
    onRowClick: (rowData, rowMeta) => {
      // console.log(rowData, rowMeta);
      fetch_custnoDetail(authreducerState.user,rowData[0]);
    },
    searchProps: {
      autoFocus: false,
      onKeyUp:(e) => {
        if (e.key === 'Enter' || e.keyCode === 13) {          
          var rowsCounter = 0;
          var custid = null;
          customersState.reduce( (previousValue, currentValue, currentIndex, array) => {          
            if(rowsCounter > 1){
              return null;
            }

            if(superSearch()(e.target.value, {...currentValue}).numberOfMatches>0){
              custid = currentValue['CUSTID']
              rowsCounter++
            }

            return rowsCounter;
          }, 0)

          if(rowsCounter === 1){
            fetch_custnoDetail(authreducerState.user,custid);
          }
          else if(e.target.value.length === 6 && e.target.value.substring(0,2) === 'ME'){
            var menardsCustno = e.target.value
            fetch_custnoDetail(authreducerState.user,0,menardsCustno);
            window.scrollTo({ top: 0, behavior: 'smooth' }); 
          }
        }
      }
    }       
  };

  const componentRef = useRef();

  const PrintButton = () => (

    <Tooltip disableFocusListener title="Print Blank Core/Rotate Form">
      <div id='divIdPrintBtn'>
        <ReactToPrint
          trigger={() => <IconButton id='printBtnCustomerCorePage'><Print /> Print Blank Core/Rotate Form</IconButton>}
          content={() => componentRef.current}
        />
  
        <span style={{ display: "none",}}>
          <span ref={componentRef}>
            <CustomerCorePrintPage  />
          </span>
        </span>
      </div>
    </Tooltip>
  );

  return (

    <div>
      <div>  
        <div id='custsTblId' className='landingPageTblClass'>
            
            { customersState !== undefined &&
                customersState !== null ?
                  customersState.length === 0 ?
                    <EmptyMuiDataTable  title={'No Customers'} />
                    : 
                    <MUIDataTable
                        title={"Customers"}
                        data={customersState}
                        columns={columnsCustomers}
                        options={optionsCustomers}
                    />             
              : ''
            }

        </div>

        <div id='custnoTblId' className='detailTblClass'>
 
            { 
             custnoDetailState !== undefined && custnoDetailState !== null ?
             Object.keys(custnoDetailState).length > 0 ?                
               
                <div>  
                   
                   <PrintButton/>

                    <table id='custnoDetailTblHeader'>
                      <thead>
                        <tr>
                          <th colSpan='2'>Custno Detail</th>
                        </tr>
                      </thead>
                      <tbody>  
                        <tr>
                          <td colSpan='2'>Note: Do not limit customer return to core bank qty</td>
                        </tr>
                        <tr>
                          { custnoDetailState['CUSTNO'] !== undefined ? 
                            <React.Fragment>
                              <td>Customer#:</td>
                              <td>
                                { custnoDetailState['CUSTNO']}
                              </td>
                            </React.Fragment>                                     
                            :
                            <React.Fragment>
                              <td></td>
                              <td></td>
                            </React.Fragment>                                
                          }
                        </tr> 
                        <tr>
                          { custnoDetailState['CUSTNAME'] !== undefined ? 
                            <React.Fragment>
                              <td>Custname:</td>
                              <td>
                                { custnoDetailState['CUSTNAME'] }
                              </td>
                            </React.Fragment>                                     
                            :
                            <React.Fragment>
                              <td></td>
                              <td></td>
                            </React.Fragment>                                
                          }
                        </tr>   
                        <tr>
                          { custnoDetailState['ADDRESS'] !== undefined ? 
                            <React.Fragment>
                              <td>Address:</td>
                              <td>
                                { custnoDetailState['ADDRESS'] } 
                                <br/>{ custnoDetailState['CUSTCITY'] }, { custnoDetailState['CUSTSTATE'] } { custnoDetailState['ZIP'] }  
                                <br/>{ custnoDetailState['PHONE'] }  
                                <br/>{ custnoDetailState['EMAIL'] }                                   
                              </td>
                            </React.Fragment>                                     
                            :
                            <React.Fragment>
                              <td></td>
                              <td></td>
                            </React.Fragment>                                
                          }
                        </tr> 
                        <tr>
                          { custnoDetailState['INSTRUCTIONS'] !== undefined ? 
                            <React.Fragment>
                              <td>Instructions:</td>
                              <td>
                                { custnoDetailState['INSTRUCTIONS']}
                              </td>
                            </React.Fragment>                                     
                            :
                            <React.Fragment>
                              <td></td>
                              <td></td>
                            </React.Fragment>                                
                          }
                        </tr> 
                        <tr>
                          { custnoDetailState['LASTSALE'] !== undefined ? 
                            <React.Fragment>
                              <td>Last Invoice:</td>
                              <td>
                                { custnoDetailState['LASTSALE']}
                              </td>
                            </React.Fragment>                                     
                            :
                            <React.Fragment>
                              <td></td>
                              <td></td>
                            </React.Fragment>                                
                          }
                        </tr>
                        <tr>
                          { custCoreBankState['CORE_BANK_QTY'] !== undefined ? 
                            <React.Fragment>
                              <td>Core Bank Qty:</td>
                              <td>
                                { custCoreBankState['CORE_BANK_QTY']}
                              </td>
                            </React.Fragment>                                     
                            :
                            <React.Fragment>
                              <td></td>
                              <td></td>
                            </React.Fragment>                                
                          }
                        </tr>                                                                                                                                                                                                        
                      </tbody>
                    </table>                  

                    {
                    (authreducerState.user.role_name === undefined) ? "" :                    
                    (authreducerState.user.role_name !== 'ADMIN' && authreducerState.user.role_name !== 'EDITOR') ? "" 
                    :                                           
                      custnoDetailState['USER_CUST_PERMISSIONID'] <= 1 ?                                                                                         
                        <div id='corePickupDivId'>
                            <table id='corePickupLocTbl'>
                              <thead>                            
                              </thead>
                              <tbody>
                              
                                <tr>
                                  <td style={ {fontWeight:'bold', textAlign:'end'} }>Loc:</td>
                                  <td>
                                    {custnoDetailState['USER_HAS_MULTIPLE_LOCS'] !== undefined && custnoDetailState['USER_HAS_MULTIPLE_LOCS'] === true ?                                                    
                                      <input
                                        id='iCorePickupLocCustomers'
                                        className={'userInputField corePickupLocCN'}
                                        type='number'
                                        maxLength='3'
                                        min='0'
                                        max='999'
                                        name='corePickupLoc'
                                        defaultValue={''}
                                        onInput={(e) => {
                                          var min = e.target.min
                                          var max = e.target.max
                                          var val = parseInt(e.target.value) || (min - 1); // if input char is not a number the value will be (min - 1) so first condition will be true
                                          if (val < min){
                                            corePickupState['LOC'] = min
                                            e.target.value = min
                                          }
                                          else if (val > max){
                                            corePickupState['LOC'] = max 
                                            e.target.value = max 
                                          }                       
                                          else{
                                            corePickupState['LOC'] = e.target.value                                 
                                          }

                                        }}                                  
                                      />                                                        
                                  :
                                    <span>
                                    {custnoDetailState['USERLOC_IF_SINGLELOC_FOR_CORES'] !== undefined && custnoDetailState['USERLOC_IF_SINGLELOC_FOR_CORES'] > 0 ?                                                                                                                                
                                      corePickupState['LOC'] = custnoDetailState['USERLOC_IF_SINGLELOC_FOR_CORES'] 
                                      :
                                      'Error. Please contact FMP personal for correction with user location.'
                                    }                                      
                                    </span>
                                    
                                  }
                                </td>
                              </tr>
                              <tr>
                              <td style={ {fontWeight:'bold', textAlign:'end'} }>Default Loc:</td>
                              <td>{custnoDetailState['CUSTLOC']} ({custnoDetailState['LOC_CITY']},{custnoDetailState['LOC_STATE']}) </td>
                            </tr>
                            <tr>
                              <td style={ {fontWeight:'bold', textAlign:'end'} }>Cust's City,State:</td>
                              <td>{custnoDetailState['CUSTCITY']},{custnoDetailState['CUSTSTATE']} </td>
                            </tr>                                
                            </tbody>
                          </table>  
                          
                          <table id='corePickupCommentTblId'>
                              <thead></thead>
                              <tbody>
                                  <tr>
                                    <td>Customer PO/Comments</td>
                                    <td>
                                      <input
                                        id='iCoreCustomerPoComments'
                                        className={'userInputField'}
                                        type='text'
                                        maxLength='100'
                                        name='corePickupCustomerPoComments'
                                        defaultValue={''}
                                        onInput={(e) => {
                                          corePickupState['CUSTOMER_PO_COMMENT'] = e.target.value    
                                        }}
                                      /> 
                                    </td>
                                  </tr>

                              </tbody>
                          </table>

                          <table id='corePickupTblId'>
                            {/* <caption>Cores Picked up</caption> */}
                            <thead>
                              <tr>
                                <th>Type</th>
                                <th>Pickup Qty</th>                  
                              </tr>
                            </thead>
                            { 
                            // custnoDetailState['CORETYPE_CUSTOMER_RESTRICTION'] !== undefined && custnoDetailState['CORETYPE_CUSTOMER_RESTRICTION'] === true ?
                            //   <tbody>
                            //   </tbody>
                            // :
                              <tbody>
 
                            
                                <tr>
                                  <td>
                                    BCRSM-CORE (U1's, Small SLA's, Power Sport)                  
                                  </td>  
                                  <td>
                                    <input 
                                      id='iCoreSmEaPickupQty_Cust'
                                      className={'userInputField'}
                                      type='number' 
                                      name='nCoreSmEaPickupQty_Cust' 
                                      min="0"       
                                      max="500"
                                      defaultValue={0}                   
                                      onChange={(e) => {
                                        //note corePickupState key matches views.py submitOrdernoDetail() coreDict key
                                        if(e.target.value === '0'){
                                          delete corePickupState['CORE_SM_QTY']                                          
                                        }
                                        else{
                                          corePickupState['CORE_SM_QTY'] = e.target.value 
                                        }                                        
                                      }
                                      }
                                    />                      
                                  </td>  
                                </tr>

                                <tr>
                                  <td>
                                    BCRMD-CORE (Auto/Marine <span style={ {textDecoration:'underline'} }>not</span> group 31)               
                                  </td>
                                  <td>
                                    <input 
                                      id='iCoreMDPickupQty_Cust'
                                      className={'userInputField'}
                                      type='number' 
                                      name='nCoreMDPickupQty_Cust'                      
                                      min="0"       
                                      max="500"
                                      defaultValue={0}               
                                      onChange={(e) => {
                                        //note corePickupState key matches views.py submitOrdernoDetail() coreDict key  
                                        if(e.target.value === '0'){
                                          delete corePickupState['CORE_MD_QTY']
                                        }
                                        else{
                                          corePickupState['CORE_MD_QTY'] = e.target.value   
                                        }   
                                          
                                        }
                                      }
                                    />                      
                                  </td>                     
                                </tr>

                                <tr>
                                  <td>
                                    BCRLG-CORE (4D, 8D & <span style={ {textDecoration:'underline'} }>All</span> group 31)                 
                                  </td>
                                  <td>
                                    <input 
                                      id='iCoreLGPickupQty_Cust'
                                      className={'userInputField'}
                                      type='number' 
                                      name='nCoreLGPickupQty_Cust'                      
                                      min="0"       
                                      max="500"
                                      defaultValue={0}               
                                      onChange={(e) => {
                                        //note corePickupState key matches views.py submitOrdernoDetail() coreDict key
                                        if(e.target.value === '0'){
                                          delete corePickupState['CORE_LG_QTY']
                                        }
                                        else{
                                          corePickupState['CORE_LG_QTY'] = e.target.value   
                                        }
                                          
                                        }
                                      }
                                    />                      
                                  </td>                     
                                </tr>   

                                <tr>
                                  <td>
                                    BCRCOREGOLF-EA (Golf)                   
                                  </td>  
                                  <td>
                                    <input 
                                      id='iCoreGolfPickupQty_Cust'
                                      className={'userInputField'}
                                      type='number' 
                                      name='nCoreGolfPickupQty_Cust'                      
                                      min="0"       
                                      max="500"
                                      defaultValue={0}                   
                                      onChange={(e) => {
                                        //note corePickupState key matches views.py submitOrdernoDetail() coreDict key 
                                        if(e.target.value === '0'){
                                          delete corePickupState['CORE_GOLF_QTY']
                                        }
                                        else{
                                          corePickupState['CORE_GOLF_QTY'] = e.target.value   
                                        }                                          
                                      }
                                      }
                                    />                      
                                  </td>  
                                </tr>                                                                                                           
                              </tbody>
                            }

                          </table>
                        </div>                        
                      : ''
                    } 

                  <div className='rotateRequestDiv' id='rotateRequestCustDetailPageId'>
                    {fetch_InventoryDetailPartnos(authreducerState.user, custnoDetailState.CUSTLOC)}


                    <div className='rotateRequestPrompt'>
                      <div style={{float:'left', padding:'0 32px 3px 0'}}>
                        Enter <span style={{textDecoration:'underline', fontWeight:'bold'}}>New Rotate Request </span>for custno {custnoDetailState['CUSTNO']}
                      </div>

                      <div className='rotateRequestPrompt' style={{float:'right'}}>
                        Shelves Checked: NO ROTATE NEEDED
                        <input 
                          id='iNoRotateNeededCb'
                          className={'userInputField'}
                          type='checkbox'
                          name='noRotateNeededCbName'                   
                          checked={noRotatesNeededCbState}
                          onChange={(e) => {
                            if(noRotatesNeededCbState === false){
                              dispatchSetNoRotatesNeededCbState(true);   
                            }
                            else{
                              dispatchSetNoRotatesNeededCbState(false);                                                          
                            }
                          }}
                        />                      
                      </div>                       
                    </div> 

                    <div className='rotateRequestPrompt' style={{float:'left', padding:'0 0 6px 0'}}>
                      Note: rotate request tickets are generated each morning
                    </div> 

                    { noRotatesNeededCbState===false && <RotateRequestTable custid={custnoDetailState.CUSTID} custloc={custnoDetailState.CUSTLOC} /> }

                  </div> 

                  <div className='returnsDiv' id='returnsCustDetailPageId'>

                    <div className='returnsPrompt'>
                      <div style={{float:'left', padding:'0 32px 3px 0'}}>
                        Enter <span style={{textDecoration:'underline', fontWeight:'bold'}}>New Returns </span>for custno {custnoDetailState['CUSTNO']}
                      </div>

                      <div className='returnsPrompt' style={{float:'right'}}>
                        Shelves Checked: NO RETURNS NEEDED
                        <input 
                          id='iNoReturnsNeededCb'
                          className={'userInputField'}
                          type='checkbox'
                          name='noReturnsNeededCbName'                   
                          checked={noReturnsNeededCbState}
                          onChange={(e) => {
                            if(noReturnsNeededCbState === false){
                              dispatchSetNoReturnsNeededCbState(true);   
                            }
                            else{
                              dispatchSetNoReturnsNeededCbState(false);                                                          
                            }
                          }}
                        />                      
                      </div>                       
                    </div> 

                    <div className='returnsPrompt' style={{float:'right', padding:'5px 0 6px 0', textAlign:'end'}}>
                      <div >
                        Original Invoice #
                        <input 
                          id='iOriginalInvoiceNo'
                          className={'userInputField'}
                          type='text'
                          name='originalInvoiceNoName' 
                          onInput={ e => {
                            setReturnsCommentState({...returnsCommentState, ORIGINALINVNO: e.target.value})
                          }}                           
                        /> 
                      </div>

                      <div >
                        Original Ticket #
                        <input 
                          id='iOriginalTicketNo'
                          className={'userInputField'}
                          type='text'
                          name='originalTicketNoName'  
                          onInput={ e => {
                            setReturnsCommentState({...returnsCommentState, ORIGINALTICKET: e.target.value})

                          }}  
                        />   
                      </div>  

                      <div >
                        Original PO #
                        <input 
                          id='iOriginalPo'
                          className={'userInputField'}
                          type='text'
                          name='originalPoName' 
                          onInput={ e => {
                            setReturnsCommentState({...returnsCommentState, ORIGINALPO: e.target.value})
                            
                          }}                                
                        />   
                      </div>                                                                        
                    </div>                     

                    { noReturnsNeededCbState===false && <ReturnsTable custid={custnoDetailState.CUSTID} custloc={custnoDetailState.CUSTLOC} /> }

                  </div> 

                  <button type='button' id='backToCustomers' onClick={()=>{window.location.href='/'}}>Back</button>                  

                  {
                  (authreducerState.user.role_name === undefined) ? "" :                    
                  (authreducerState.user.role_name !== 'ADMIN' && authreducerState.user.role_name !== 'EDITOR' && authreducerState.user.role_name !== 'VIEWER_ROTATES') ? "" 
                  :                                      
                    (custnoDetailState['USER_CUST_PERMISSIONID'] <= 1 || custnoDetailState['USER_CUST_PERMISSIONID'] === 3) ? 
                        custServerResponseState !== undefined && custServerResponseState !== null && 
                        Object.keys(custServerResponseState).length > 0 &&
                        custServerResponseState['SUCCESSFUL_UPDATES'] !== '' ? 
                          <React.Fragment>
                            {fetch_landingPageStates(authreducerState.user)}
                          </React.Fragment>
                      :
                      <button type='button' id='submitCustnoDetail' onClick={(e)=> 
                        {   
                          let checkCorePickUpState = (corePickupState.hasOwnProperty('CORE_MD_QTY') || 
                          corePickupState.hasOwnProperty('CORE_SM_QTY') ||
                          corePickupState.hasOwnProperty('CORE_GOLF_QTY') ||
                          corePickupState.hasOwnProperty('CORE_LG_QTY')) 

  
                          if(custnoDetailState['USER_CUST_PERMISSIONID'] === 3){

                            if (window.confirm('Click Ok to submit confirmation or Cancel to not submit confirmation.')) 
                            {
                              const noCorePickupState = {}
                              fetch_submitCustnoDetail(custnoDetailState,noCorePickupState,authreducerState.user.userid, returnsCommentState) 
                              window.scrollTo({ top: 0, behavior: 'smooth' });
                            }
                            else 
                            {
                              console.log('Cancelled - Submit delivery was not saved.');
                            }                                                      
                          }
                          else if(checkCorePickUpState === false){
                            if (window.confirm('Please proceed if there are no cores picked up for current custno or click cancel to enter cores.')) 
                            {
                              if (window.confirm('Click Ok to submit confirmation or Cancel to not submit confirmation.')) 
                              {
                                const noCorePickupState = {}
                                fetch_submitCustnoDetail(custnoDetailState,noCorePickupState,authreducerState.user.userid, returnsCommentState) 
                                window.scrollTo({ top: 0, behavior: 'smooth' });
                              }
                              else 
                              {
                                console.log('Cancelled - Submit delivery was not saved.');
                              }    
                            }
                            else 
                            {
                              console.log('Cancelled - Submit delivery was not saved. May re-enter cores if needed');
                            }                                
                          }
                          else{
                            if(corePickupState['LOC'] === undefined || corePickupState['LOC'] === '0' || corePickupState['LOC'] === '999' || corePickupState['LOC'] === ''){
                              alert('Please enter a core loc.')
                            }
                            else{
                              if (window.confirm('Click Ok to submit transaction or Cancel to not submit transaction.')) 
                              {
                                corePickupState['CUSTID'] = custnoDetailState['CUSTID']
                                corePickupState['USERID'] = authreducerState.user.userid
                                
                                fetch_submitCustnoDetail(custnoDetailState,corePickupState,authreducerState.user.userid, returnsCommentState) 
  
                                document.getElementById('submitCustnoDetail').style.visibility = "show";
                                if(custServerResponseState !== undefined)
                                {
                                  if(Object.keys(custServerResponseState).length > 0)
                                  {
                                    if(custServerResponseState['SUCCESSFUL_UPDATES'] !== '' )
                                    {
                                      document.getElementById('submitCustnoDetail').style.visibility = "hidden";
                                    }                             
                                  }
                                }                                  
                              } 
                              else 
                              {
                                console.log('Cancelled - Order was not saved.');
                              } 
                            }
                          }                                                                                    
                        }                    
                      }>Submit</button>
                      : ''
                  } 
                </div>


                 : ''
               :''
            }

        </div>


      </div>
    </div>

  );
}



const mapStateToProps = (state) => {
  return { 
    customersState: state.customersReducer['items_fetchCustomers'],
    custnoDetailState: state.customersReducer['items_fetchCustnoDetail'],
    custCoreBankState: state.customersReducer['items_fetchCustCoreBank'],
    corePickupState: state.customersReducer['items_fetchCorePickup'], 
    rotateRequestState: state.rotatesReducer['items_rotateRequestState'],  
    noRotatesNeededCbState: state.rotatesReducer['noRotatesNeededCbState'],

    returnsState: state.returnsReducer['items_returnsState'],  
    noReturnsNeededCbState: state.returnsReducer['noReturnsNeededCbState'],

    
    custServerResponseState: state.statusUpdateReducer['custServerResponse'],    
    authreducerState: state.authreducer
  }

};

const mapDispatchToProps = (dispatch) => {
  return {
    fetch_landingPageStates: (user) => {
      dispatch(fetchOrders(user));
      dispatch(fetchTransfers(user));
      dispatch(fetchCustomers(user));
      dispatch(fetchInventory(user));
    },    
    fetch_customers: (user) => {
      dispatch(fetchCustomers(user));
    },
    fetch_custnoDetail: (user, custid, searchCustno='') => {
      dispatch(fetchCustnoDetail(user, custid, searchCustno));
    }, 
    fetch_submitCustnoDetail: (custnoDetailState,corePickupState, userid, returnsCommentState) => {
      dispatch(fetchSubmitCustnoDetail(custnoDetailState,corePickupState, userid, returnsCommentState));
    },
    dispatchSetNoRotatesNeededCbState: (result) => {
      dispatch(setNoRotatesNeededCbState(result));
    },  
    
    dispatchSetNoReturnsNeededCbState: (result) => {
      dispatch(setNoReturnsNeededCbState(result));
    },  

    fetch_InventoryDetailPartnos: (user, loc) => {
      dispatch(fetchInventoryDetailPartnos(user, loc));
    }        
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Customers);